import styled, { css } from 'styled-components'
import { TGridLayout } from '~/components/product-item/types'
import theme from '~/gatsby-plugin-theme-ui'

type TColorsSizes = Record<
  TGridLayout,
  {
    margin: (number | null)[]
    size: (number | null)[]
  }
>

export const ColorsSizes: TColorsSizes = {
  'template-default': {
    margin: [10, null, 10, 15],
    size: [40, null, 50, 50],
  },
  'template-furniture': {
    margin: [10, null, 10, 15],
    size: [30, null, 40, 50],
  },
  'template-inStock': {
    margin: [10, null, 10, 15],
    size: [40, null, 50, 50],
  },
  'template-lastChance': {
    margin: [10, 10, 15],
    size: [40, 60, 60],
  },
  'template-rugs': {
    margin: [10, null, 10, 15],
    size: [40, null, 50, 50],
  },
}

export const ColorsRow = styled.div<{ gridLayout: TGridLayout }>`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  margin-bottom: 4px;
  width: 100%;

  ${({ gridLayout }) => css`
    > li {
      margin-right: ${ColorsSizes[gridLayout].margin[0]}px;

      @media (min-width: ${theme.breakpoints[1]}) {
        margin-right: ${ColorsSizes[gridLayout].margin[1]}px;
      }

      @media (min-width: ${theme.breakpoints[2]}) {
        margin-right: ${ColorsSizes[gridLayout].margin[2]}px;
      }
    }
  `}

  a,
  button {
    width: 100%;
    height: 100%;
    margin: 0;
  }
`
